import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

const FilterPanel = ({ filters, onFilterChange, onReset, resultsCount, availableMills = [] }) => {
  const { t } = useTranslation();

  const stateOptions = [
    { value: 'all', label: t('marketplace.allStates', 'All States') },
    { value: 'MH', label: 'Maharashtra' },
    { value: 'UP', label: 'Uttar Pradesh' },
    { value: 'KA', label: 'Karnataka' },
    { value: 'TN', label: 'Tamil Nadu' },
    { value: 'GJ', label: 'Gujarat' }
  ];

  const gradeOptions = [
    { value: 'all', label: t('marketplace.allGrades', 'All Grades') },
    { value: 'S30', label: 'S-30' },
    { value: 'M30', label: 'M-30' },
    { value: 'L30', label: 'L-30' },
    { value: 'S31', label: 'S-31' }
  ];

  const distanceOptions = [
    { value: 'all', label: t('marketplace.anyDistance', 'Any Distance') },
    { value: '<300', label: t('marketplace.within300km', 'Within 300 km') },
    { value: '300-600', label: '300 – 600 km' },
    { value: '600-1000', label: '600 – 1000 km' },
    { value: '>1000', label: t('marketplace.above1000km', 'Above 1000 km') }
  ];

  const millOptions = [
    { value: 'all', label: t('marketplace.allFactories', 'All Factories') },
    ...(availableMills?.filter(m => m?.value !== 'all') || [])
  ];

  return (
    <div className="rounded-2xl px-5 py-4 mb-6 border" style={{ background: '#ffffff', borderColor: 'rgba(0,0,0,0.1)', backdropFilter: 'blur(8px)' }}>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 text-sm font-semibold mr-1" style={{ color: '#475569' }}>
          <Icon name="SlidersHorizontal" size={15} style={{ color: '#d97706' }} />
          {t('common.filter')}:
        </div>

        {/* State */}
        <div className="min-w-[150px]">
          <Select
            options={stateOptions}
            value={filters?.state}
            onChange={(value) => onFilterChange('state', value)}
            placeholder={t('marketplace.state', 'State')}
          />
        </div>

        {/* Sugar Factory */}
        <div className="min-w-[200px]">
          <Select
            options={millOptions}
            value={filters?.mill}
            onChange={(value) => onFilterChange('mill', value)}
            placeholder={t('marketplace.sugarFactory', 'Sugar Factory')}
            searchable
          />
        </div>

        {/* Grade */}
        <div className="min-w-[130px]">
          <Select
            options={gradeOptions}
            value={filters?.grade}
            onChange={(value) => onFilterChange('grade', value)}
            placeholder={t('common.grade')}
          />
        </div>

        {/* Distance */}
        <div className="min-w-[160px]">
          <Select
            options={distanceOptions}
            value={filters?.distanceSlab}
            onChange={(value) => onFilterChange('distanceSlab', value)}
            placeholder={t('marketplace.distance', 'Distance')}
          />
        </div>

        {/* Results count + Reset */}
        <div className="flex items-center gap-3 ml-auto">
          <span className="text-sm font-medium" style={{ color: '#64748b' }}>
            <span style={{ color: '#d97706', fontWeight: 700 }}>{resultsCount}</span> {t('marketplace.listingsFound', 'listings found')}
          </span>
          <Button variant="ghost" size="sm" iconName="RotateCcw" iconPosition="left" onClick={onReset}>
            {t('marketplace.reset', 'Reset')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;